import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tag,
  message,
  Descriptions,
  Button,
  Tabs,
  Spin,
  Typography,
  Table,
  Modal,
  Form,
  Input,
  Select,
} from "antd";
import { useParams, Link } from "react-router-dom";
import {
  UserOutlined,
  CarOutlined,
  FileTextOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  DollarCircleOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;
const { Option } = Select;

const TransactionDetail = () => {
  const { id } = useParams();
  const [transactionData, setTransactionData] = useState(null);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [withdrawalLoading, setWithdrawalLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    fetchTransactionDetails();
    fetchWithdrawalHistory();
  }, [id]);

  const fetchTransactionDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`http://93.127.203.113:5005/transactions/${id}`);
      setTransactionData(response.data);
    } catch (error) {
      message.error("Failed to fetch transaction details.");
    } finally {
      setLoading(false);
    }
  };

  const fetchWithdrawalHistory = async () => {
    try {
      setWithdrawalLoading(true);
      const response = await axios.get(`http://93.127.203.113:5005/withdrawals/${id}`);
      setWithdrawalHistory(response.data);
    } catch (error) {
      message.error("Failed to fetch withdrawal history.");
    } finally {
      setWithdrawalLoading(false);
    }
  };

  const handleAddWithdrawal = async (values) => {
    try {
      await axios.post("http://93.127.203.113:5005/withdrawals", {
        ...values,
        transactionId: id,
        ownerId: transactionData.owner.id,
      });
      message.success("Withdrawal recorded successfully");
      setIsModalVisible(false);
      fetchWithdrawalHistory(); // Refresh withdrawals after adding
    } catch (error) {
      message.error("Failed to record withdrawal");
    }
  };

  // Function to generate receipt
  const generateReceipt = () => {
    if (!transactionData) return;

    const receiptContent = `
      <html>
        <head>
          <title>Transaction Receipt</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            h1 { color: #0c8c49; }
            .receipt { border: 1px solid #ddd; padding: 20px; border-radius: 10px; max-width: 500px; margin: auto; }
            .receipt-header { text-align: center; margin-bottom: 20px; }
            .receipt-details { margin-bottom: 20px; }
            .receipt-details p { margin: 5px 0; }
            .receipt-footer { text-align: center; margin-top: 20px; font-size: 12px; color: #666; }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="receipt-header">
              <h1>Transaction Receipt</h1>
              <p>Date: ${new Date().toLocaleDateString()}</p>
            </div>
            <div class="receipt-details">
              <p><strong>Owner Name:</strong> ${transactionData.owner?.name || "N/A"}</p>
              <p><strong>Passenger:</strong> ${transactionData.customer_agreement?.passenger
                ? `${transactionData.customer_agreement.passenger.firstName} ${transactionData.customer_agreement.passenger.lastName}`
                : "N/A"}</p>
              <p><strong>Vehicle:</strong> ${transactionData.vehicle?.plateNumber || "N/A"}</p>
              <p><strong>Start Date:</strong> ${new Date(transactionData.startDate).toLocaleDateString()}</p>
              <p><strong>End Date:</strong> ${new Date(transactionData.endDate).toLocaleDateString()}</p>
              <p><strong>Total Amount:</strong> $${transactionData.totalWithVAT?.toFixed(2) || "0.00"}</p>
            </div>
            <div class="receipt-footer">
              <p>Thank you for using our service!</p>
            </div>
          </div>
        </body>
      </html>
    `;

    const receiptWindow = window.open("", "_blank");
    receiptWindow.document.write(receiptContent);
    receiptWindow.document.close();
  };

  const WithdrawalForm = () => {
    const [form] = Form.useForm();

    const onFinish = (values) => {
      handleAddWithdrawal(values);
    };

    return (
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Amount"
          name="amount"
          rules={[{ required: true, message: "Please enter the withdrawal amount" }]}
        >
          <Input type="number" placeholder="Enter amount" />
        </Form.Item>
        <Form.Item
          label="Payment Method"
          name="paymentMethod"
          rules={[{ required: true, message: "Please select a payment method" }]}
        >
          <Select placeholder="Select payment method">
            <Option value="cash">Cash</Option>
            <Option value="bank_transfer">Bank Transfer</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Remarks" name="remarks">
          <Input.TextArea placeholder="Optional remarks" rows={3} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ backgroundColor: "#0c8c49" }}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    );
  };

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Transaction Details
          </Title>
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={generateReceipt}
            style={{ marginBottom: "20px", backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}
          >
            Generate Receipt
          </Button>
          <Tabs defaultActiveKey="1" type="card">
            {/* Transaction Overview */}
            <TabPane
              tab={
                <span>
                  <ArrowRightOutlined /> Transaction Overview
                </span>
              }
              key="1"
            >
              <Row gutter={[24, 24]}>
                <Col span={24} md={12}>
                  <Card
                    title="Transaction Information"
                    bordered={false}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Owner Name">
                        {transactionData?.owner?.name || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Passenger">
                        {transactionData?.customer_agreement?.passenger
                          ? `${transactionData.customer_agreement.passenger.firstName} ${transactionData.customer_agreement.passenger.lastName}`
                          : "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Vehicle">
                        {transactionData?.vehicle?.plateNumber || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Price Per Day">
                        <Tag color="#0c8c49">${transactionData?.pricePerDay}</Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Start Date">
                        {transactionData?.startDate
                          ? new Date(transactionData.startDate).toLocaleDateString()
                          : "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="End Date">
                        {transactionData?.endDate
                          ? new Date(transactionData.endDate).toLocaleDateString()
                          : "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
                <Col span={24} md={12}>
                  <Card
                    title="Payment Information"
                    bordered={false}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Working Days">
                        {transactionData?.workingDays || 0}
                      </Descriptions.Item>
                      <Descriptions.Item label="Days Not Worked">
                        {transactionData?.daysNotWorked || 0}
                      </Descriptions.Item>
                      <Descriptions.Item label="To Be Paid to Owner">
                        ${transactionData?.toBePaidToOwner?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item label="VAT">
                        ${transactionData?.VAT?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Total With VAT">
                        ${transactionData?.totalWithVAT?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Withholding">
                        ${transactionData?.withholding?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Net Collected">
                        ${transactionData?.netCollected?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Profit">
                        ${transactionData?.profit?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Commission">
                        ${transactionData?.commission?.toFixed(2) || "0.00"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
              </Row>
            </TabPane>

            {/* Owner Information */}
            <TabPane
              tab={
                <span>
                  <UserOutlined /> Owner Details
                </span>
              }
              key="2"
            >
              <Card
                title="Owner Information"
                bordered={false}
                extra={
                  transactionData?.owner && (
                    <Link to={`/ownerDetails/${transactionData.owner.id}`}>
                      <Button type="link" style={{ color: "#0c8c49" }}>
                        View Owner Details
                      </Button>
                    </Link>
                  )
                }
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Owner Name">
                    {transactionData?.owner?.name || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contact">
                    {transactionData?.owner?.contact || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {transactionData?.owner?.email || "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            {/* Vehicle Information */}
            <TabPane
              tab={
                <span>
                  <CarOutlined /> Vehicle Details
                </span>
              }
              key="3"
            >
              <Card
                title="Vehicle Information"
                bordered={false}
                extra={
                  transactionData?.vehicle && (
                    <Link to={`/vehicleDetails/${transactionData.vehicle.id}`}>
                      <Button type="link" style={{ color: "#0c8c49" }}>
                        View Vehicle Details
                      </Button>
                    </Link>
                  )
                }
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Plate Number">
                    {transactionData?.vehicle?.plateNumber || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Model">
                    {transactionData?.vehicle?.model || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Color">
                    {transactionData?.vehicle?.color || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Manufactured Year">
                    {transactionData?.vehicle?.manufacturedYear || "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            {/* Customer Agreement */}
            {transactionData?.customer_agreement && (
              <TabPane
                tab={
                  <span>
                    <FileTextOutlined /> Customer Agreement
                  </span>
                }
                key="4"
              >
                <Card
                  title="Customer Agreement Information"
                  bordered={false}
                  extra={
                    transactionData?.customer_agreement?.agreementId && (
                      <Link
                        to={`/customerAgreementDetails/${transactionData.customer_agreement.agreementId}`}
                      >
                        <Button type="link" style={{ color: "#0c8c49" }}>
                          View Agreement
                        </Button>
                      </Link>
                    )
                  }
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Descriptions bordered column={1}>
                    <Descriptions.Item label="Start Date">
                      {transactionData?.customer_agreement?.startDate
                        ? new Date(transactionData.customer_agreement.startDate).toLocaleDateString()
                        : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="End Date">
                      {transactionData?.customer_agreement?.endDate
                        ? new Date(transactionData.customer_agreement.endDate).toLocaleDateString()
                        : "N/A"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Price Per Day">
                      ${transactionData?.customer_agreement?.pricePerDay || 0}
                    </Descriptions.Item>
                  </Descriptions>
                </Card>
              </TabPane>
            )}

            {/* Withdrawal History */}
            <TabPane
              tab={
                <span>
                  <DollarCircleOutlined /> Withdrawal History
                </span>
              }
              key="5"
            >
              <Card
                title="Withdrawal History"
                extra={
                  <Button
                    type="primary"
                    onClick={() => setIsModalVisible(true)}
                    style={{
                      backgroundColor: "#0c8c49",
                      borderColor: "#0c8c49",
                    }}
                  >
                    Add Withdrawal
                  </Button>
                }
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                {withdrawalLoading ? (
                  <Spin size="large" />
                ) : (
                  <Table
                    dataSource={withdrawalHistory}
                    rowKey="withdrawalId"
                    columns={[
                      {
                        title: "Amount",
                        dataIndex: "amount",
                        key: "amount",
                        render: (text) => `$${text}`,
                      },
                      {
                        title: "Date",
                        dataIndex: "createdAt",
                        key: "createdAt",
                        render: (date) => {
                          return date ? new Date(date).toLocaleDateString() : "N/A";
                        },
                      },
                      {
                        title: "Payment Method",
                        dataIndex: "paymentMethod",
                        key: "paymentMethod",
                      },
                      {
                        title: "Remarks",
                        dataIndex: "remarks",
                        key: "remarks",
                      },
                    ]}
                  />
                )}
              </Card>
            </TabPane>
          </Tabs>
        </Card>
      )}

      {/* Withdrawal Modal */}
      <Modal
        title="Add Withdrawal"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <WithdrawalForm />
      </Modal>
    </div>
  );
};

export default TransactionDetail;